import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { NetworkFilterKey } from '@core/events/filter.events';
import { NetworkFilterPill, PeriodFilterPill } from '@core/stores/filter.store';

/**
 * The period and network pills of a filter, as the app header shows them. A pill with more values
 * than fit opens a dropdown listing them all, unless `expanded` is set: then each filter is plain
 * text (no pill background or border) with every value inline — for places that are themselves an
 * overlay (the download history's filter popover), where a nested dropdown would be fragile and
 * long values outgrow a pill.
 */
@Component({
  selector: 'app-filter-pills',
  imports: [OverlayModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './filter-pills.component.html',
  host: { class: 'block' },
})
export class FilterPillsComponent {
  readonly periodPill = input<PeriodFilterPill | null>(null);
  readonly networkPills = input<NetworkFilterPill[]>([]);
  readonly expanded = input(false);
  // the header lays its pills out on one scrolling row; the popover stacks them one per line
  readonly wrap = input(false);

  readonly openPillKey = signal<NetworkFilterKey | null>(null);

  togglePillDropdown(key: NetworkFilterKey): void {
    this.openPillKey.set(this.openPillKey() === key ? null : key);
  }

  closePillDropdown(): void {
    this.openPillKey.set(null);
  }
}
